module.exports = __webpack_public_path__ + "static/img/02.a87b5f3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/daytours/tour5/02.jpg
// module id = 8bvl
// module chunks = 0